import sinistres from '@amo/core/assets/images/AMO_Icons/Sinistres.svg';
import RecapGPTSection from './RecapGPTSection';
import RecapGPTRow from './RecapGPTRow';

const formatCrm = (value) => {
    if (!value) return null;
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    return num < 1 ? `Bonus ${Math.round((1 - num) * 100)}%` : num > 1 ? `Malus ${Math.round((num - 1) * 100)}%` : 'Neutre (1.00)';
};

const boolLabel = (val) => {
    if (val === undefined || val === null) return null;
    return String(val) === '1' || val === true || val === 'true' ? 'Oui' : 'Non';
};

const formatNbMois = (val) => {
    if (val === undefined || val === null) return null;
    const n = parseInt(val, 10);
    if (isNaN(n)) return null;
    return n === 0 ? 'Non assuré' : `${n} mois sur les 24 derniers`;
};

const RecapGPTAntecedents = ({ personne, antecedents, onEdit }) => (
    <RecapGPTSection title="Mes antécédents" icon={sinistres} onEdit={onEdit}>
        <RecapGPTRow label="CRM moto" value={formatCrm(personne?.ValeurCrmMoto)} />
        <RecapGPTRow label="CRM auto" value={formatCrm(personne?.ValeurCrmAuto)} />
        <RecapGPTRow label="Assurance moto" value={formatNbMois(personne?.NbMoisAssuranceMoto)} />
        <RecapGPTRow label="Assurance auto" value={formatNbMois(personne?.NbMoisAssuranceAuto)} />
        <RecapGPTRow label="Suspension de permis" value={boolLabel(antecedents?.SuspensionPermis)} />
        <RecapGPTRow label="Annulation de permis" value={boolLabel(antecedents?.AnnulationPermis)} />
        <RecapGPTRow label="Résiliation par un assureur" value={boolLabel(antecedents?.ResiliationAssureur)} />
        <RecapGPTRow label="Condamnation alcoolémie" value={boolLabel(antecedents?.CondamnationAlcoolemie)} />
        <RecapGPTRow label="Condamnation stupéfiants" value={boolLabel(antecedents?.CondamnationStupefiants)} />
        <RecapGPTRow label="Condamnation délit de fuite" value={boolLabel(antecedents?.CondamnationDelitFuite)} />
        <RecapGPTRow label="Condamnation conduite sans assurance" value={boolLabel(antecedents?.CondamnationConduiteSansAssurance)} />
        <RecapGPTRow label="Nombre de sinistres" value={antecedents?.NbSinistres !== undefined ? String(antecedents.NbSinistres) : null} />
    </RecapGPTSection>
);

export default RecapGPTAntecedents;
